import React, { createContext, useEffect, useState } from 'react';
import copy from 'copy-to-clipboard';
import { toast } from 'react-toastify';

export const NewContext = createContext();

const NewContextProvider = ({ children }) => {
    const [token, setToken] = useState(localStorage.getItem('token'));
    const [tokenType, setTokenType] = useState(localStorage.getItem('loginType') || 'standard');
    useEffect(() => {
        setTokenType(localStorage.getItem('loginType'))
    }, [localStorage.getItem('loginType')])

    const [permissions, setPermissions] = useState(tokenType === 'ldap' && token?.split('.')[1] ? JSON.parse(atob(token?.split('.')[1]))?.permission : {})
    const [selectedDates, setSelectedDates] = useState([]);

    const [sortData, setsortData] = useState('');
    const [isAscending, setIsAscending] = useState(false);
    const [expiryTime, setExpiryTime] = useState(null);
    const [deleteUpdateYes, setDeleteUpdateYes] = useState("");
    const [deleteUpdateTag, setDeleteUpdateTag] = useState("");
    const [search, setSearch] = useState("");
    const [addEditDeleteTag, setAddEditDeleteTag] = useState("");
    const [currentHomeModalKey, setCurrentHomeModalKey] = useState("");
    const [currentUserId, setCurrentUserId] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [currentThemePage, setCurrentThemePage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [perPage, setPerPage] = useState(15);

    const [childModalCurrentPage, setChildModalCurrentPage] = useState(1);
    const [childModalTotalPage, setchildModalTotalPage] = useState(1);
    const [childModalperPage, setChildModalPerPage] = useState(8);

    const [toggleSidebar, setToggleSidebar] = useState(false);
    const [confirmationModalShow, setConfirmationModalShow] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isModalLoading, setIsModalLoading] = useState(false);
    const [isSubModalLoading, setIsSubModalLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const [currentPageData, setCurrentPageData] = useState([]);
    const [currentModalTableData, setCurrentModalTableData] = useState([]);
    const [childModalTableData, setChildModalTableData] = useState([]);
    const [homeScreenData, setHomeScreenData] = useState([]);
    const [homeTableData, setHomeTableData] = useState([]);
    const [checkedValues, setCheckedValues] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [range, setRange] = useState({});
    const [filterDate, setFilterDate] = useState("");
    const [openPreview, setopenPreview] = useState(false);
    const [openSubCategory, setopenSubCategory] = useState(false);
    const [selectedAssetOptions, setSelectedAssetOptions] = useState([]);
    const [apiResponse, setApiResponse] = useState(null);


    // const [multiTag, setMultiTag] = useState([]);
    const [multiCountry, setMultiCountry] = useState([]);
    const [multiRegion, setMultiRegion] = useState([]);

    const [formData, setFormData] = useState({});
    const [imgObj, setImgObj] = useState({});
    const [deleteUpdateItem, setDeleteUpdateItem] = useState({});
    const [filterDropdown, setFilterDropdown] = useState({});
    const [childFilterDropdown, setChildFilterDropdown] = useState({});
    const [isLoadMore, setIsLoadMore] = useState("")

    const [openmod, setOpenMod] = useState(false);

    const [childFormData, setChildFormData] = useState({});
    const [childOpen, setChildOpen] = useState(false);
    const [childReportOpen, setReportChildOpen] = useState(false);
    const [openReason, setopenReason] = useState(false);
    const [formDataBoolean, setFormDataBoolean] = useState(true);

    const handleChildOpen = () => setChildOpen(!childOpen);
    const handleChildClose = () => { setChildOpen(false); setChildFormData({}); setDeleteUpdateYes(""); setDeleteUpdateTag(""); setDeleteUpdateItem({}); setImgObj({}); setCheckedValues([]); setMultiCountry([]); setMultiRegion([]); };
    const handlePermissions = (permissionData) => setPermissions(permissionData);

    const handleReportChildOpen = () => setReportChildOpen(true);
    const handleReportChildClose = () => { setReportChildOpen(false); };

    const handleOpenReason = () => setopenReason(!openReason);
    const handleopenReasonClose = () => { setopenReason(false); };
    const [saveMedia, setSaveMedia] = useState(0);


    const handleChildChange = (e) => {
        if (e.target.name === "country" || e.target.name === "region") {
            let countryRegionAry = [].slice.call(e.target.selectedOptions).map(item => item.value);
            setChildFormData({ ...childFormData, [e.target.name]: countryRegionAry });
            setDeleteUpdateItem({ ...formData, [e.target.name]: countryRegionAry });
        } else {
            setChildFormData({ ...childFormData, [e.target.name]: e.target.value });
            setDeleteUpdateItem({ ...formData, [e.target.name]: e.target.value });
        }
    }
    const handleChildSwitch = (e) => setChildFormData({ ...childFormData, [e.target.name]: childFormData[e.target.name] ? false : true });

    const handleOpenbtn = () => { setOpenMod(true); };
    const handleOpensubCategory = () => { setopenSubCategory(true); };
    const handleClosebtn = () => { setOpenMod(false); };

    const handleCopyData = (_tag, _string) => { copy(_string); toast.success(`${_tag} Copied.`); };
    const handleFilterChange = (e) => { setFilterDropdown({ ...filterDropdown, [e.target.name]: e.target.value === 'true' ? true : e.target.value === 'false' ? false : e.target.value === 'asc' ? 'asc' : e.target.value === 'dsc' ? 'dsc' : "" }); setCheckedValues([]); };
    const handleCheckboxChange = (value) => { checkedValues.includes(value) ? setCheckedValues(checkedValues.filter((val) => val !== value)) : setCheckedValues([...checkedValues, value]) };
    const handleSelectAll = (e) => {
        const path = window.location.href.split('/').pop();
        const data = path === 'homescreen' ? homeScreenData : currentPageData;
        e.target.checked ? setCheckedValues([...data.map(_ele => _ele._id)]) : setCheckedValues([])
    };
    const handleDeleteAll = (_deleteUpdateYes) => { setDeleteUpdateYes(_deleteUpdateYes); setDeleteUpdateItem({ id: checkedValues }); setConfirmationModalShow(!confirmationModalShow); };
    // const handleChange = (e) => {
    //     if (e.target.name === "country" || e.target.name === "region") {
    //         let countryRegionAry = [].slice.call(e.target.selectedOptions)?.map(item => item.value);
    //         setFormData({ ...formData, [e.target.name]: countryRegionAry });
    //         setDeleteUpdateItem({ ...formData, [e.target.name]: countryRegionAry });
    //     } else {
    //         setFormData({ ...formData, [e.target.name]: e.target.value });
    //         setDeleteUpdateItem({ ...formData, [e.target.name]: e.target.value });
    //     }
    // };
    const handleChange = (e) => {
        const { name, value, selectedOptions } = e.target;
    
        if (name === "country" || name === "region") {
            let countryRegionAry = Array.from(selectedOptions).map(item => item.value);
            setFormData({ ...formData, [name]: countryRegionAry });
            setDeleteUpdateItem({ ...formData, [name]: countryRegionAry });
        } else {
            if (value.trim() !== "") {
                setFormData({ ...formData, [name]: value }); 
                setDeleteUpdateItem({ ...formData, [name]: value });
            } else {
                setFormData({ ...formData, [name]: "" });
                setDeleteUpdateItem({ ...formData, [name]: "" });
            }
        }
    };
    
    

    const handleModalClose = (e, reason) => {
        if (reason && reason === 'backdropClick') {
            return;
        }
        setOpenModal(false)
    };
    const handleLogout = () => { localStorage.clear(); toast.success("Logout successfully."); window.location.reload(); window.location.href = '/' }
    const handleSwitch = (e) => setFormData({ ...formData, [e.target.name]: formData[e.target.name] ? false : true });
    const handleSwitchUpdate = (e) => {
        setDeleteUpdateItem({ id: e.target.id, [e.target.name]: !e.target.checked ? false : true });
        setConfirmationModalShow(!confirmationModalShow)
    };
    const handleOpen = () => setOpen(!open);
    const handleClose = () => { setOpen(false); setDeleteUpdateYes(""); setDeleteUpdateTag(""); setAddEditDeleteTag(``); setCurrentHomeModalKey(``); setDeleteUpdateItem({}); setFormData({}); setChildFormData({}); setImgObj({}); setCheckedValues([]); setMultiCountry([]); setMultiRegion([]); setSelectedAssetOptions(null) };
    const capitalalizeFirstletter = (_str) => _str.charAt(0).toUpperCase() + _str.slice(1);
    const truncateString = (text, maxLength) => {
        if (text.length <= maxLength) {
            return text;
        }
        const truncationLength = maxLength // Math.floor((maxLength - 3) / 2);
        const start = text.slice(0, truncationLength);
        const end = text.slice(text.length - truncationLength);
        return `${start}...${end}`;
    }

    const updateStateAryData = (stateAry, fieldAllData, name) => {
        let blankAry = [];
        stateAry?.map(_state => {
            let stateDefaultValue;
            if (name === 'country' || name === 'gameCategory') {
                stateDefaultValue = fieldAllData?.filter(_field_all => _field_all._id === (_state?._id || _state))[0];
            } else {
                stateDefaultValue = fieldAllData?.filter(_field_all => _field_all.name.toLowerCase() === _state?.toLowerCase())[0];
            }
            blankAry.push(stateDefaultValue)
        });
        return blankAry?.map(_ele => ({ _id: _ele._id, value: name === 'country' ? _ele.code : _ele.name.toLowerCase(), label: capitalalizeFirstletter(_ele.name), name: name }))
    }
    const updateStateAryChildData = (stateAry, fieldAllData, name) => {
        let blankAry = [];
        stateAry?.map(_state => {
            let stateDefaultValue;
            if (name === 'country') {
                stateDefaultValue = fieldAllData?.filter(_field_all => _field_all._id === (_state?._id || _state))[0];
            } else {
                stateDefaultValue = fieldAllData?.filter(_field_all => _field_all.name && _field_all.name?.toLowerCase() === _state && _state?.toLowerCase())[0];
            }
            blankAry.push(stateDefaultValue)
        });
        return blankAry?.map(_ele => ({ _id: _ele && _ele._id, value: name === 'country' ? _ele.code : _ele.name.toLowerCase(), label: capitalalizeFirstletter(_ele.name), name: name }))
    }

    const handleSelectMultiCountry = (e) => {
        if (e.length > 0) {
            e.map(_ele => {
                let multiSelectAry = [].slice.call(e).map(item => item._id);
                if (_ele.name === 'country') {
                    setMultiCountry(e);
                    if (childOpen) {
                        setChildFormData({ ...childFormData, [_ele.name]: multiSelectAry })
                    } else {
                        setFormData({ ...formData, [_ele.name]: multiSelectAry })
                    }
                }
            })
        } else {
            setMultiCountry([]);
            if (childOpen) {
                setChildFormData({ ...childFormData, country: [] })
            } else {
                setFormData({ ...formData, country: [] })
            }
        }
    }
    const handleSelectMultiRegion = (e) => {
        if (e.length > 0) {
            e.map(_ele => {
                let multiSelectAry = [].slice.call(e).map(item => item._id);
                if (_ele.name === 'region') {
                    setMultiRegion(e);
                    if (childOpen) {
                        setChildFormData({ ...childFormData, [_ele.name]: multiSelectAry })
                    } else {
                        setFormData({ ...formData, [_ele.name]: multiSelectAry })
                    }
                }
            })
        } else {
            setMultiRegion([]);
            if (childOpen) {
                setChildFormData({ ...childFormData, country: [] });
            } else {
                setFormData({ ...formData, region: [] });
            }
        }
    }
    const handleFileInput = (e) => {
        if (e.target.name === "stickerPreview" || e.target.name == "bigPreviewStickerStore" || e.target.name === "faqImages" || e.target.name === "themeBigPreview") {
            let bigPreviewAry = [];
            let blobURLS = []
            for (let key of e.target.files) {
                bigPreviewAry.push(key);
                blobURLS.push(URL.createObjectURL(key));
            }
            setImgObj({ ...imgObj, [e.target.name]: blobURLS });
            setFormData({ ...formData, [e.target.name]: bigPreviewAry });
        } else if (
            e.target.name.includes("video") ||
            e.target.name.includes("videoPreview")
        ) {
            //This is for Fucture Refarce
            // Check if there's an existing file for the target name
            // if (formData?.[e.target.name] !== undefined) {
            //   // Replace the existing file with the new one
            //   formData[e.target.name] = [e.target.files[0]];
            // } else {
            //   // If there's no existing file, initialize the form data with the new file
            //   setFormData({ ...formData, [e.target.name]: [e.target.files[0]] });
            // }
            if (formData?.[e.target.name] === undefined) {
                setFormData({ ...formData, [e.target.name]: [e.target.files[0]] });
            } else {
                formData[e.target.name].push(e.target.files[0]);
                setFormData({ ...formData });
            }
        } else {
            setImgObj({ ...imgObj, [e.target.name]: URL.createObjectURL(e.target.files[0]) });
            setFormData({ ...formData, [e.target.name]: e.target.files[0] });
        }
    }
    const handleIsLoadMoreSwitch = () => { setIsLoadMore(!isLoadMore); };
    // const handleIsLoadMoreSwitch = () => { setIsLoadMore(!isLoadMore); };
    const handleSingleSelect = (name, e) => setFormData({ ...formData, [name]: e });
    const handleSingleSelectChild = (name, e) => setChildFormData({ ...childFormData, [name]: e });

    const value = {
        token, setToken,
        selectedDates, setSelectedDates,
        sortData, setsortData,
        isAscending, setIsAscending,
        expiryTime, setExpiryTime,
        tokenType, setTokenType,

        deleteUpdateYes, setDeleteUpdateYes,
        deleteUpdateTag, setDeleteUpdateTag,
        addEditDeleteTag, setAddEditDeleteTag,
        currentHomeModalKey, setCurrentHomeModalKey,
        search, setSearch,
        currentUserId, setCurrentUserId,

        currentPage, setCurrentPage,
        currentThemePage, setCurrentThemePage,
        totalPage, setTotalPage,
        perPage, setPerPage,
        openReason, setopenReason,

        permissions, setPermissions, handlePermissions,
        childModalCurrentPage, setChildModalCurrentPage,
        childModalTotalPage, setchildModalTotalPage,
        childModalperPage, setChildModalPerPage,

        toggleSidebar, setToggleSidebar,
        confirmationModalShow, setConfirmationModalShow,
        isLoading, setIsLoading,
        isModalLoading, setIsModalLoading,
        isSubModalLoading, setIsSubModalLoading,
        open, setOpen,
        openModal, setOpenModal, handleModalClose,
        childReportOpen, setReportChildOpen,

        currentPageData, setCurrentPageData,
        currentModalTableData, setCurrentModalTableData,
        childModalTableData, setChildModalTableData,
        homeScreenData, setHomeScreenData,
        homeTableData, setHomeTableData,
        checkedValues, setCheckedValues,
        selectedOptions, setSelectedOptions,
        range, setRange,
        filterDate, setFilterDate,
        openPreview, setopenPreview,
        openSubCategory, setopenSubCategory,

        // multiTag, setMultiTag,
        multiCountry, setMultiCountry,
        multiRegion, setMultiRegion,

        formData, setFormData,
        imgObj, setImgObj,
        deleteUpdateItem, setDeleteUpdateItem,
        filterDropdown, setFilterDropdown,
        childFilterDropdown, setChildFilterDropdown,
        isLoadMore, setIsLoadMore,

        openmod, setOpenMod,
        apiResponse, setApiResponse,

        childFormData, setChildFormData,
        childOpen, setChildOpen,

        handleChildOpen,
        handleReportChildOpen,
        handleReportChildClose,
        handleChildClose,
        handleChildChange,
        handleChildSwitch,
        handleOpensubCategory,

        handleCopyData,
        handleopenReasonClose,
        handleFilterChange,
        handleCheckboxChange,
        handleSelectAll,
        handleDeleteAll,
        handleIsLoadMoreSwitch,
        handleopenReasonClose,
        // handleIsLoadMoreSwitch,
        handleChange,
        handleLogout,
        handleSwitch,
        handleSwitchUpdate,
        handleOpen,
        handleClose,


        handleOpenbtn,
        handleClosebtn,
        capitalalizeFirstletter,
        updateStateAryData,
        updateStateAryChildData,
        handleSelectMultiCountry,
        handleSelectMultiRegion,
        handleFileInput,
        handleSingleSelect,
        handleSingleSelectChild,
        truncateString,
        formDataBoolean,
        setFormDataBoolean,
        setSaveMedia,
        saveMedia,
        setSelectedAssetOptions,
        selectedAssetOptions
    };
    return (
        <NewContext.Provider value={value}>
            {children}
        </NewContext.Provider>
    )
};

export default NewContextProvider;